var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"19","cy":"19","r":"19","transform":"rotate(-90 19 19)","fill":"#F6FDBA","key":0}),React.createElement("path",{"d":"M11 18.8398H26.68","stroke":"#070D0E","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18.8398 11L26.6798 18.84L18.8398 26.68","stroke":"#070D0E","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ArrowRight.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
